import { useContext, useEffect } from "react";
import { GlobalContext } from "../../context/Provider";
import { heartbeatApi } from "../../api/auth";

const HEARTBEAT_INTERVAL_MS = 45 * 1000;

const PresenceTracker = () => {
  const { authState } = useContext(GlobalContext);

  useEffect(() => {
    if (!authState.isAuthenticated) return undefined;

    const heartbeat = () => {
      if (document.visibilityState === "visible") {
        heartbeatApi().catch(() => {});
      }
    };

    heartbeat();
    const interval = window.setInterval(heartbeat, HEARTBEAT_INTERVAL_MS);
    document.addEventListener("visibilitychange", heartbeat);
    window.addEventListener("focus", heartbeat);

    return () => {
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", heartbeat);
      window.removeEventListener("focus", heartbeat);
    };
  }, [authState.isAuthenticated]);

  return null;
};

export default PresenceTracker;
